import { rateCategoryNames } from 'main/rateCategories'
import { useContext } from 'react'

import { conversionKeysToBlacklistKeys } from '../../../../../main/blacklistHelpers'
import { popularEmailProviders } from '../../../../../main/commonStatic'
import Column from '../../../Column/index'
import BlacklistContext from '../../BlackListContext'
import CheckRow, { CheckTextRow } from '../../CheckRow/index'

const blacklistables = {
  invited: ['invitedFormattedAddress', 'invitedPhoneNumber', 'invitedEmail'],
  converted: ['convertedFormattedAddress', 'convertedPhoneNumber', 'convertedEmail'],
  trackingAndRate: ['convertedTrackingCode', 'convertedRateCode']
}

const Details = ({ isMultiWithSameRate, isMultiWithSameTracking, isMultiBookings }) => (
  <>
    {!isMultiWithSameRate && !isMultiWithSameTracking && (
      <>
        <InvitedColumn />
        <ConvertedColumn />
      </>
    )}
    <RateTrackingColumn
      showRate={isMultiBookings ? isMultiWithSameRate : true}
      showTracking={isMultiBookings ? isMultiWithSameTracking : true}
    />
  </>
)

const InvitedColumn = () => <InvitedConvertedColumn type="invited" />

const ConvertedColumn = () => <InvitedConvertedColumn type="converted" />

const RateTrackingColumn = ({ showRate = true, showTracking = true }) => {
  const {
    values,
    setValue,
    setLength,
    conversion: { convertedRateCode, convertedTrackingCode, convertedRateCodeKind }
  } = useContext(BlacklistContext)

  return (
    <Column title="Rate &amp; tracking code">
      {showRate && (
        <>
          <CheckRow
            name="rateCodeFull"
            value={`${convertedRateCode} rate code`}
            setValue={setValue}
            checked={values.rateCodeFull}
            detail={
              convertedRateCodeKind ? (
                <>{rateCategoryNames[convertedRateCodeKind]} rate</>
              ) : (
                <span
                  style={{
                    backgroundColor: 'var(--red)',
                    color: 'white',
                    padding: '1px 4px',
                    fontSize: 11
                  }}
                >
                  Unknown rate
                </span>
              )
            }
          />
          <CheckTextRow
            name="rateCodeStartsWith"
            title="Rate code starts with"
            defaultVal={convertedRateCode}
            setValue={setValue}
            setLength={setLength}
            checked={values.rateCodeStartsWith}
          />
        </>
      )}
      {showTracking && (
        <>
          <CheckRow
            name="trackingInfoFull"
            value={`${convertedTrackingCode} tracking code`}
            setValue={setValue}
            checked={values.trackingInfoFull}
          />
        </>
      )}
    </Column>
  )
}

const InvitedConvertedColumn = ({ type }) => {
  const { values, setValue, conversion } = useContext(BlacklistContext)

  let email = conversion[type === 'invited' ? 'invitedEmail' : 'convertedEmail']
  const domain = email && email.match(/@.+/) ? email.match(/@.+/)[0].toLowerCase() : null

  return (
    <Column title={type === 'invited' ? 'Invited guest info' : 'Converted guest info'}>
      {blacklistables[type].map(
        d =>
          isConversationValValid(conversion, d) && (
            <CheckRow
              setValue={setValue}
              name={conversionKeysToBlacklistKeys[d]}
              value={conversion[d]}
              key={d}
              checked={values[conversionKeysToBlacklistKeys[d]]}
            />
          )
      )}
      {domain && !popularEmailProviders.includes(domain.replace('@', '')) && (
        <CheckRow
          setValue={setValue}
          value={domain}
          name={type === 'invited' ? 'invitedEmailDomain' : 'convertedEmailDomain'}
          checked={
            type === 'invited' ? values.invitedEmailDomain : values.convertedEmailDomain
          }
        />
      )}
    </Column>
  )
}

function isConversationValValid(conversation, d) {
  if (d.includes('Email')) {
    return conversation[d] && conversation[d].match(/@.+/)
  }

  return conversation[d]
}

export default Details
